const pageFlow = {
  flow: {
    form: {
      inputParameter: 'Input Parameter'
    }
  }
}

export default pageFlow
